<div data-testid="app-root" style="display: flex; flex-direction: column; height: 100vh; width:100%; visibility: visible;" [style.visibility]="isReady === true ? 'visible' : 'hidden'">
  <!-- Only render content after authentication state is fully resolved -->
  <ng-container *ngIf="isReady; else loading">
    <!-- Do not switch to authenticated layout while still on a callback route.
         Doing so would destroy the callback router-outlet and re-mount
         SignInRedirectCallbackComponent, which would attempt a second completeLogin()
         against an already-consumed OIDC code and redirect to /login. -->
    <ng-container *ngIf="isLoggedIn && !isAuthCallbackRoute(); else unauthenticated" data-testid="authenticated-container">
      <app-side-nav-inner-toolbar data-testid="main-layout" title="{{appInfo.title}}" style="flex: 1; display: flex; flex-direction: column; height: 100vh;">
        <router-outlet data-testid="router-outlet" (activate)="updateScrollbarVisibility()">
        </router-outlet>
      </app-side-nav-inner-toolbar>


      <!-- Session Warning Component -->
      <app-session-warning data-testid="session-warning"></app-session-warning>

      <!-- Token Testing Component (Development Only) -->
      <!-- <app-token-testing data-testid="app-token-testing"></app-token-testing> -->

      <!-- Custom horizontal scrollbar that stays visible above footer -->
      <div data-testid="global-scrollbar" id="globalScrollbar" style="overflow-x: auto; overflow-y: hidden; height: 17px !important; min-height: 17px !important; max-height: 17px !important; width: 100%; border-top: 1px solid #ddd; background-color: #f8f8f8; display: none; position: relative;">
        <div data-testid="scrollbar-content" id="scrollbarContent" style="height: 1px !important; width: 1000px; background-color: transparent; cursor: pointer;"></div>
      </div>

      <app-footer data-testid="app-footer">
        <img data-testid="logo-image" src="../assets/images/M_Logo.png" alt="MountStreet logo" style="height: 20px; width:20px; vertical-align: middle;"/>
        <span id="footer-copyright-text" style="cursor: default;">
          Copyright &copy; 2024-{{appInfo.currentYear}} {{appInfo.title}} Version {{appInfo.version}}.
          All trademarks or registered trademarks are property of their respective owners.
        </span>
        <dx-tooltip
          target="#footer-copyright-text"
          showEvent="click"
          [hideEvent]="{ name: 'click', delay: 3000 }">
          <div *dxTemplate="let data of 'content'" style="max-width: 320px; white-space: normal;">
            Copyright &copy; 2024-{{appInfo.currentYear}} {{appInfo.title}} Version {{appInfo.version}}.
            All trademarks or registered trademarks are property of their respective owners.
          </div>
        </dx-tooltip>
      </app-footer>
    </ng-container>
    <ng-template #unauthenticated>
      <!-- Allow signin-callback and signout-callback routes to render even when not authenticated -->
      <router-outlet *ngIf="isAuthCallbackRoute()" data-testid="callback-router-outlet"></router-outlet>
      <app-unauthenticated-content *ngIf="!isAuthCallbackRoute()" data-testid="unauthenticated-content"></app-unauthenticated-content>
    </ng-template>
  </ng-container>

  <!-- Loading state: show spinner while authentication check is in progress -->
  <ng-template #loading>
    <div data-testid="authentication-loading" style="display: flex; justify-content: center; align-items: center; height: 100vh; width: 100%; position: fixed; top: 0; left: 0; z-index: 9999; background: white;">
      <dx-load-panel
        [visible]="true"
        [showPane]="true"
        [shading]="false"
        [height]="100"
        [width]="100">
      </dx-load-panel>
    </div>
  </ng-template>
</div>
